/// <reference types="vite/client" />
export const BASE_API_URL =
  "https://dxgn02z9kk.execute-api.eu-west-2.amazonaws.com/prod/v1/";
export const WEBSOCKET_URL =
  "wss://6alr2o8rhc.execute-api.eu-west-2.amazonaws.com/prod";
export const FILE_BASE_URL =
  "https://business-crm-prod.s3.eu-west-2.amazonaws.com/";
export const WIDGET_URL = "https://widget.kelu.uk/";
export const PADDLE_CLIENT_TOKEN = "live_a9924fff8b99f4787630be8fc5a";
export const PUBLIC_POSTHOG_KEY =
  "phc_tTSyR5njP4bSa8o3PuQ2R3EDJ7SkX6gum3DFsv4RU3cW";
export const PUBLIC_POSTHOG_HOST = "https://us.i.posthog.com";